import {
  axios
} from '@/main.js'
import store from '@/js/store/store'

//加载所有下拉列表
//使用 store.getters["模块名/getters方法名"]获取对应项
export function InitAll(userType, OwnedStationCode) {
  //平台管理员 额外加载以下
  if (userType == 0) {
    getStation(true).then(res => {
      if (res.data.Code === "10000") {
        store.dispatch("dropDown/saveStationsList", res.data.Data);
      }
    });

  } else if (userType == 1) {
    getStation(true).then(res => {
      if (res.data.Code === "10000") {
        store.dispatch("dropDown/saveStationsList", res.data.Data);
      }
    });
  }
  getLoginNames(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveLoginNameList", res.data.Data);
    }
  });
  getRoles(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveUserRoleList", res.data.Data);
    }
  });

  if (userType == 1) {
    // getInspectionFee(true, OwnedStationCode).then(res => {
    //     if (res.data.Code === "10000") {
    //         store.dispatch("dropDown/saveInspectionFeeList", res.data.Data);
    //     }
    // });
    // getInspectionServiceFee(true, OwnedStationCode).then(res => {
    //     if (res.data.Code === "10000") {
    //         store.dispatch("dropDown/saveInspectionServiceFeeList", res.data.Data);
    //     }
    // });
    // getEnvironmentalFee(true, OwnedStationCode).then(res => {
    //     if (res.data.Code === "10000") {
    //         store.dispatch("dropDown/saveEnvironmentalFeeList", res.data.Data);
    //     }
    // });
    // getEnvironmentalServiceFee(true, OwnedStationCode).then(res => {
    //     if (res.data.Code === "10000") {
    //         store.dispatch("dropDown/saveEnvironmentalServiceFeeList", res.data.Data);
    //     }
    // });
    // getAddedFee(true, OwnedStationCode).then(res => {
    //     if (res.data.Code === "10000") {
    //         store.dispatch("dropDown/saveAddedCheckBox", res.data.Data);
    //     }
    // });

    // getDeviceType(true).then(res => {
    //     if (res.data.Code === "10000") {
    //         store.dispatch("dropDown/saveDeviceTypeList", res.data.Data);
    //     }
    // });
  }

  getGroup(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveGroupList", res.data.Data);
    }
  });

  getLicenseType(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveLicenseTypeList", res.data.Data);
    }
  })


  getDetectionType(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveDetectionTypeList", res.data.Data);
    }
  })

  getVehicleCategory(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveVehicleCategoryList", res.data.Data);
    }
  })

  getFuelType(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveFuelTypeList", res.data.Data);
    }
  })

  getUseNature(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveUseNatureList", res.data.Data);
    }
  })

  getTariffItem(true, OwnedStationCode).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveTariffItemList", res.data.Data);
    }
  })

  getTariffAdditive(true, OwnedStationCode).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveTariffAdditiveList", res.data.Data);
    }
  })

  getWareHouseAdditive(true, OwnedStationCode).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveWareHouseAdditiveList", res.data.Data);
    }
  })

  getTariffPackage(true, OwnedStationCode).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveTariffPackageList", res.data.Data);
    }
  })

  getMember(true, OwnedStationCode).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveMemberList", res.data.Data);
    }
  })

  getPersonType(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/savePersonTypeList", res.data.Data);
    }
  });

  getDrivingType(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveDrivingTypeList", res.data.Data);
    }
  });

  getGroupTree(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveGroupTreeList", res.data.Data);
    }
  });
  getCouponCategoryList(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveCouponCategoryList", res.data.Data)
    }
  });
  getCouponTypeList(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveCouponTypeList", res.data.Data)
    }
  });
  getCouponFromList(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveCouponFromList", res.data.Data)
    }
  });
  getCouponUsingList(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveCouponUsingList", res.data.Data)
    }
  });
  getMiniProgramStatusList(true).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveMiniProgramStatusList", res.data.Data);
    }
  });

  getChargeCategory(true,OwnedStationCode).then(res => {
    if (res.data.Code === "10000") {
      store.dispatch("dropDown/saveChargeCategoryList", res.data.Data);
    }
  });
}

// 模块：得到可配置的下拉列表项，数据均来自于数据字典。
//得到角色下拉列表
export function getRoles(refreshCache = false) {
  return axios({
    url: 'UserRole/GetRoleDropDownList',
    method: 'post',
    data: {
      refreshCache: refreshCache
    }
  })
};

//得到登录名下拉列表
export function getLoginNames(refreshCache = false) {
  return axios({
    url: 'User/GetLoginNameList',
    method: 'post',
    data: {
      refreshCache: refreshCache
    }
  })
};

/**
 * 得到检测站列表(未删除的)
 * @param refreshCache 是否刷新服务端缓存
 */
export function getStation(refreshCache = false) {
  return axios({
    url: '/VIStationInfo/GetVIStationInfoDropdownList',
    method: 'post',
    data: {
      refreshCache: refreshCache,
      IsDel: 0
    }
  })
};

/**
 * 得到检测站列表(全部的)
 * @param refreshCache 是否刷新服务端缓存
 */
export function getStationAll(refreshCache = false) {
  return axios({
    url: '/VIStationInfo/GetVIStationInfoDropdownList',
    method: 'post',
    data: {
      refreshCache: refreshCache
    }
  })
};

/**
 * 得到集团列表
 * @param refreshCache 是否刷新服务端缓存
 */
export function getGroup(refreshCache = false) {
  return axios({
    url: '/Group/GetGroupInfoDropdownList',
    method: 'post',
    data: {
      refreshCache: refreshCache
    }
  })
};

//得到检测类别
export function getDetectionType(refreshCache = false) {
  return axios({
    url: '/DictCode/GetDetectionTypeDict',
    method: 'post',
    data: {}
  })
}

//得到车辆类别
export function getVehicleCategory(refreshCache = false) {
  return axios({
    url: '/DictCode/GetVehicleCategoryDict',
    method: 'post',
    data: {}
  })
}

//得到燃油类别
export function getFuelType(refreshCache = false) {
  return axios({
    url: '/DictCode/GetFuelTypeDict',
    method: 'post',
    data: {}
  })
}

//得到使用性质
export function getUseNature(refreshCache = false) {
  return axios({
    url: '/DictCode/GetUseNatureDict',
    method: 'post',
    data: {}
  })
}

//得到收费项目
export function getTariffItem(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/InspectionService/GetInspectionService',
    method: 'post',
    data: {
      StationCode: OwnedStationCode,
      Name: "",
      ServiceType: "1",
      PageSize: 1000,
      PageIndex: 1
    }
  })
}

//得到增值产品
export function getTariffAdditive(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/InspectionService/GetInspectionService',
    method: 'post',
    data: {
      StationCode: OwnedStationCode,
      Name: "",
      ServiceType: "5",
      PageSize: 1000,
      PageIndex: 1
    }
  })
}

//得到增值产品
export function getWareHouseAdditive(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/WareHouseInfo/GetWareHouseInfoList',
    method: 'post',
    data: {
      WareHouseName: "",
      WareHouseNo: "",
      WareHouseTarget: "1",
      WareHouseType: "0",
      PageSize: 1000,
      PageIndex: 1
    }
  })
}

//得到收费套餐
export function getTariffPackage(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/PriceTemplate/GetPriceTemplate',
    method: 'post',
    data: {
      StationCode: OwnedStationCode,
      TemplateName: "",
      IsDeleted: false,
      PageSize: 1000,
      PageIndex: 1
    }
  })
}

//得到会员
export function getMember(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/VipUser/GetVipUserSimpleList',
    method: 'post',
    data: {
      StationCode: OwnedStationCode,
      VipUserNameOrMobile: "",
      VipUserType: "",
      VipUserStatus: "",
      IsDeleted: false,
      PageSize: 1000,
      PageIndex: 1
    }
  })
}

//得到号牌种类子列表
export function getLicenseType(refreshCache = false) {
  return axios({
    url: '/DictCode/GetLicenseTypeDict',
    method: 'post',
    data: {}
  })
}

//得到收费类型列表
export function getChargeType(refreshCache = false) {
  return axios({
    url: '/DictCode/GetChargeTypeDict',
    method: 'post',
    data: {}
  })
}
//获取收费类别
export function getChargeCategory(refreshCache = false,OwnedStationCode) {
  return axios({
    url: '/ChargeType/GetChargeTypeList',
    method: 'post',
    data: {
      OwnedStationCode:OwnedStationCode,
      ChargeName: "",
      PageIndex: 1,
      PageSize: 500,
    }
  })
}
//得到人员类型列表
export function getPersonType(refreshCache = false) {
  return axios({
    url: '/DictCode/GetPersonTypeDict',
    method: 'post',
    data: {
      refreshCache: refreshCache
    }
  })
}

//得到设备类型列表
export function getDeviceType(refreshCache = false) {
  return axios({
    url: '/DictCode/GetDeviceTypeDict',
    method: 'post',
    data: {}
  })
}

//得到检测费用
export function getInspectionFee(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/InspectionService/GetInspectionDropdownList',
    method: 'post',
    data: {
      ServiceType: "检测费用",
      StationCode: OwnedStationCode
    }
  })
}

//得到检测服务费用
export function getInspectionServiceFee(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/InspectionService/GetInspectionDropdownList',
    method: 'post',
    data: {
      ServiceType: "检测服务费用",
      StationCode: OwnedStationCode
    }
  })
}

//得到环保检测费用
export function getEnvironmentalFee(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/InspectionService/GetInspectionDropdownList',
    method: 'post',
    data: {
      ServiceType: "非安检费用",
      StationCode: OwnedStationCode
    }
  })
}

//得到环检服务费用
export function getEnvironmentalServiceFee(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/InspectionService/GetInspectionDropdownList',
    method: 'post',
    data: {
      ServiceType: "非安检服务费用",
      StationCode: OwnedStationCode
    }
  })
}

//得到增值服务
export function getAddedFee(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/InspectionService/GetInspectionDropdownList',
    method: 'post',
    data: {
      ServiceType: "增值服务",
      StationCode: OwnedStationCode
    }
  })
}
//得到驾驶证类别列表
export function getDrivingType(refreshCache = false, OwnedStationCode) {
  return axios({
    url: '/DictCode/GetDrivingTypeDict',
    method: 'post',
    data: {}
  })
}
//得到数据字典类型列表
export function getAllDictTypeList(refreshCache = false) {
  return axios({
    url: '/DictCode/GetAllDictType',
    method: 'post',
    data: {}
  })
}

/**
 * 得到集团树列表
 * @param refreshCache 是否刷新服务端缓存
 */
export function getGroupTree(refreshCache = false) {
  return axios({
    url: '/Group/GetGroupInfoTreeDropdownList',
    method: 'post',
    data: {
      refreshCache: refreshCache
    }
  })
};
//得到优惠券品类
export function getCouponCategoryList(refreshCache = fasle) {
  return axios({
    url: '/DictCode/GetCouponCategory',
    method: 'post',
    data: {}
  });
};
//得到优惠券类型
export function getCouponTypeList(refreshCache = false) {
  return axios({
    url: '/DictCode/GetCouponType',
    method: 'post',
    data: {}
  });
};
//得到优惠券来源
export function getCouponFromList(refreshCache = false) {
  return axios({
    url: '/DictCode/GetCouponFrom',
    method: 'post',
    data: {}
  });
};
//得到优惠券集合状态
export function getCouponUsingList(refreshCache = false) {
  return axios({
    url: '/DictCode/GetCouponUsing',
    method: 'post',
    data: {}
  });
};
//得到优惠券使用状态
export function getMiniProgramStatusList(refreshCache = false) {
  return axios({
    url: '/DictCode/GetMiniProgramStatusList',
    method: 'post',
    data: {}
  });
};

//得到培训类型
export function getTrainingCategory(refreshCache = false) {
  return axios({
    url: '/DictCode/GetTrainingCategoryDict',
    method: 'post',
    data: {}
  })
};

//得到培训对象
export function getTrainingObject(refreshCache = false) {
  return axios({
    url: '/DictCode/GetTrainingObjectDict',
    method: 'post',
    data: {}
  })
};

//得到培训方式
export function getTrainingMethod(refreshCache = false) {
  return axios({
    url: '/DictCode/GetTrainingMethodDict',
    method: 'post',
    data: {}
  })
};

//得到考核方式
export function getEvaluationMethod(refreshCache = false) {
  return axios({
    url: '/DictCode/GetEvaluationMethodDict',
    method: 'post',
    data: {}
  })
};


// WEBPACK FOOTER //
// ./src/js/DropDownList.js